import React from "react";
import ReactPlayer from "react-player";

import {
  VideoPopupWrapper,
  VideoTitle,
  VideoSubtitle,
  VideoFrameWrapper,
} from "./video-popup.styles";

import { buildAbsoluteDownloadUrl } from "../../utils/FileDownload";
import Dialog from "../ui/Dialog";
import styled from "styled-components";


/**
 * Close button positioned at top-right of dialog
 */
const DialogClose = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 20px;

  border: none;
  background: transparent;

  cursor: pointer;

  z-index: 2;
`;

/**
 * VideoPopup component to display re-registration instructional video
 *
 * @param {Object} props
 * @param {boolean} props.open - Controls dialog visibility
 * @param {Function} props.onOpenChange - Handles dialog close/open state
 * @param {string} props.iframe - Embedded iframe HTML or URL string
 * @param {string} props.videoUrl - Direct video file URL
 * @returns {JSX.Element}
 */
const VideoPopup = ({
  open,
  onOpenChange,
  iframe = "",
  videoUrl = "",
}) => {
  const hasIframe = Boolean(iframe);
  const hasVideoUrl = Boolean(videoUrl);

  const resolvedVideoUrl = hasVideoUrl
    ? buildAbsoluteDownloadUrl(videoUrl)
    : "";


  const extractedIframeUrl =
    iframe?.match(/src="([^"]+)"/)?.[1] || iframe;

  const iframeSourceUrl = `${extractedIframeUrl}?autoplay=1`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <VideoPopupWrapper>
        <DialogClose onClick={onOpenChange}>
          <i className="fa-light fa-xmark" />
        </DialogClose>

        <VideoTitle>How to Re-Register</VideoTitle>

        <VideoSubtitle>
          Watch the guide below to learn how to submit your re-registration
        </VideoSubtitle>

        <VideoFrameWrapper>
          {hasIframe ? (
            <iframe
              src={iframeSourceUrl}
              allow="autoplay; fullscreen"
              allowFullScreen
              title="Re-Registration Video"
              width="100%"
              height="100%"
            />
          ) : hasVideoUrl ? (
            <ReactPlayer
              url={resolvedVideoUrl}
              controls
              playing
              width="100%"
              height="100%"
              muted={false}
            />
          ) : (
            <p>No video available</p>
          )}
        </VideoFrameWrapper>
      </VideoPopupWrapper>
    </Dialog>
  );
};

export default VideoPopup;